import { GetListParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { fetchCoinSymbolOverview, probeImageUrl } from '../../../services/coinImagesService';
import { Resources } from '../../resource';

class CoinSymbolsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== Resources.coinSymbols) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }

    const page = params.pagination?.page ?? 1;
    const perPage = params.pagination?.perPage ?? 50;
    const symbol = String(params.filter?.symbol ?? '').trim();

    const result = await fetchCoinSymbolOverview({
      symbol: symbol || undefined,
      limit: perPage,
      offset: (page - 1) * perPage,
    });

    const items = await Promise.all(
      result.items.map(async (item) => ({
        ...item,
        id: item.symbol,
        hlImageAvailable: await probeImageUrl(item.hycoinUrl),
      })),
    );

    items.sort((a, b) => Number(a.hlImageAvailable) - Number(b.hlImageAvailable));

    return {
      data: items,
      total: result.total,
    };
  }
}

export const dataProvider = new CoinSymbolsDataProvider();

registerModuleDataProvider(Resources.coinSymbols, dataProvider);
